import { useState } from "react";
import { Check } from "lucide-react";
import { useT } from "../../i18n";

const split = (s) => (s ? s.split(",") : []);

const Chip = ({ on, onClick, children, testId }) => (
  <button type="button" aria-pressed={on} onClick={onClick} data-testid={testId}
    className={`inline-flex min-h-[44px] items-center gap-2 border px-3.5 text-left text-[13px] transition-colors duration-300 ${on ? "border-ink bg-ink text-white" : "border-ink/20 text-ink hover:border-ink/60"}`}>
    {on && <Check size={13} strokeWidth={2} />}
    {children}
  </button>
);

// "4WD/AWD" and "Turbo" sit with equipment for buyers but query the drivetrain / aspiration fields.
const QUICK = [["drivetrain", "4wd,awd", "filters.quick4wd"], ["aspiration", "turbo,twincharger", "filters.quickTurbo"]];

export const EquipmentFilter = ({ value, onChange, facets, groups = [], idPrefix }) => {
  const t = useT();
  const [q, setQ] = useState("");
  const selected = split(value.equipment);
  const opts = facets?.equipment || [];
  const toggle = (k) => onChange({ equipment: (selected.includes(k) ? selected.filter((s) => s !== k) : [...selected, k]).join(",") });
  const match = (o) => !q || o.label.toLowerCase().includes(q.toLowerCase());
  return (
    <div className="grid gap-5" data-testid={`${idPrefix}-equipment`}>
      <div className="flex flex-wrap gap-2">
        {QUICK.map(([field, val, label]) => (
          <Chip key={field} on={value[field] === val} onClick={() => onChange({ [field]: value[field] === val ? "" : val })} testId={`${idPrefix}-quick-${field}`}>{t(label)}</Chip>
        ))}
      </div>
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder={t("filters.searchEquipment")} data-testid={`${idPrefix}-equipment-search`}
        className="h-11 w-full border border-ink/20 px-3.5 text-[15px] focus:border-ink focus:outline-none lg:text-sm" />
      {groups.map((g) => {
        const items = opts.filter((o) => o.group === g.key && (match(o) || selected.includes(o.value)));
        if (!items.length) return null;
        return (
          <fieldset key={g.key}>
            <legend className="micro-label mb-3 opacity-55">{g.label}</legend>
            <div className="flex flex-wrap gap-2">
              {items.map((o) => (
                <Chip key={o.value} on={selected.includes(o.value)} onClick={() => toggle(o.value)} testId={`${idPrefix}-eq-${o.value}`}>
                  {o.label} <span className="tabular-nums opacity-50">{o.count}</span>
                </Chip>
              ))}
            </div>
          </fieldset>
        );
      })}
    </div>
  );
};
